module.exports = __webpack_public_path__ + "static/media/dota-logo.ceb52606.png";